// extracted by mini-css-extract-plugin
export default {"container":"room_photos_section_container__PvNCo"};